import { render } from "./EmployeeTimesheet.vue?vue&type=template&id=22f37140"
import script from "./EmployeeTimesheet.vue?vue&type=script&lang=js"
export * from "./EmployeeTimesheet.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__